import { render, staticRenderFns } from "./UserMainPage.vue?vue&type=template&id=e819f224&scoped=true"
import script from "./UserMainPage.vue?vue&type=script&lang=js"
export * from "./UserMainPage.vue?vue&type=script&lang=js"
import style0 from "./UserMainPage.vue?vue&type=style&index=0&id=e819f224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e819f224",
  null
  
)

export default component.exports